import { useTranslation } from "react-i18next";
import { useState, useEffect, useRef } from "react";
import i18n from "i18next";
import {
  getAggregatedData,
  getAggregatedDataWrapper,
  onFilterModelChange,
  renderGrid,
  aggregatedAdministrativeTableColumns,
} from "./AgroAnalyticsUtils";

export const aggregatedProvinceTableColumns = () => [
  {
    field: "Anno",
    headerName: i18n.t("agriculture.year"),
    width: 60,
  },

  {
    field: "Compagnia",
    headerName: i18n.t("company"),
    width: 60,
  },

  {
    field: "Provincia",
    headerName: i18n.t("state"),
    width: 20,
  },
  ...aggregatedAdministrativeTableColumns(),
];

export const AgroProvinceGrid = ({ filterModel, wantedReferenceDateProp }) => {
  const { t } = useTranslation();

  const [aggregatedProvinceTableState, setAggregatedProvinceTableState] = useState({
    isLoading: false,
    total: 0,
  });

  const aggregatedProvinceCancelTokenRef = useRef(null);

  const [aggregatedProvinceTableData, setAggregatedProvinceTableData] = useState([]);

  useEffect(() => {
    const getAggregatedProvinceData = async () => {
      return await getAggregatedData(
        setAggregatedProvinceTableState,
        setAggregatedProvinceTableData,
        { aggr: "Provincia" },
        filterModel,
        wantedReferenceDateProp,
        aggregatedProvinceCancelTokenRef,
      );
    };
    const getAggregatedProvinceDataWrapper = async () => {
      getAggregatedDataWrapper(aggregatedProvinceCancelTokenRef, getAggregatedProvinceData);
    };

    onFilterModelChange(filterModel, getAggregatedProvinceDataWrapper);
  }, [filterModel, wantedReferenceDateProp]);

  return renderGrid(
    aggregatedProvinceTableColumns(),
    aggregatedProvinceTableData,
    aggregatedProvinceTableState,
    t,
    "Province",
  );
};
